import { render, staticRenderFns } from "./CreateTime.vue?vue&type=template&id=be743eb0&"
import script from "./CreateTime.vue?vue&type=script&lang=js&"
export * from "./CreateTime.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports